export * from "./admin-campaign-partners.dto";
